import React, { Suspense, lazy, useEffect, useState } from 'react';
import { Dialog } from 'primereact/dialog';
import './SovSimulator.scss';

// Ładowany dopiero przy otwarciu — nie dokłada nic do głównej paczki.
const SovSimulator = lazy(() => import('./SovSimulator'));

const SEQUENCE = ['ArrowUp', 'ArrowUp', 'ArrowDown', 'ArrowDown', 'ArrowLeft', 'ArrowRight', 'ArrowLeft', 'ArrowRight', 'b', 'a'];

/**
 * Okno symulatora Share of Voice. Otwiera je sekwencja klawiszy (↑ ↑ ↓ ↓ ← → ← → B A) — nasłuch na całym
 * oknie. Bez backendu i bez śledzenia — rekord trzyma `localStorage` przeglądarki.
 */
const SovSimulatorDialog: React.FC = () => {
  const [visible, setVisible] = useState(false);
  // Treść zostaje w oknie do końca animacji zamykania — odmontowana od razu zwijała okno w trakcie
  // wygaszania. Zdejmowana w `onExited`, co zatrzymuje też pętlę animacji i nasłuch klawiszy.
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    let position = 0;
    const onKeyDown = (event: KeyboardEvent) => {
      const target = event.target as HTMLElement | null;
      // Bez łapania sekwencji w polach tekstowych — „b”, „a” i strzałki to zwykłe pisanie.
      if (target?.closest('input, textarea, [contenteditable="true"]')) return;
      const key = event.key.length === 1 ? event.key.toLowerCase() : event.key;
      position = key === SEQUENCE[position] ? position + 1 : key === SEQUENCE[0] ? 1 : 0;
      if (position === SEQUENCE.length) {
        position = 0;
        setIsMounted(true);
        setVisible(true);
      }
    };

    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, []);

  return (
    <Dialog
      header="Share of Voice"
      visible={visible}
      onHide={() => setVisible(false)}
      className="dialog-box sov-sim-dialog"
      draggable={false}
      dismissableMask
      // `timeout` jak domyślny PrimeReacta dla okna na środku — typy wymagają go razem z callbackiem.
      transitionOptions={{ timeout: 150, onExited: () => setIsMounted(false) }}
    >
      {isMounted && (
        <Suspense fallback={<div className="sov-sim sov-sim--loading" />}>
          <SovSimulator />
        </Suspense>
      )}
    </Dialog>
  );
};

export default SovSimulatorDialog;
